import script from "./clientinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./clientinfo.vue?vue&type=script&setup=true&lang=js"

import "./clientinfo.vue?vue&type=style&index=0&id=1a473925&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a473925"]])

export default __exports__